/*global jQuery, $ */

import Shopnavi from './../config';
import Nanobar from 'nanobar';

let favoriteIndicator = new Nanobar({
  classname: 'loading-indicator',
});

$(document).ready(function () {
  var b = $('.neer_image');
  var aticleH = b.width();
  $('.neer_image').css('height', aticleH);
});

$(function () {
  $(window).on('resize', function () {
    var b = $('.neer_image');
    var aticleH = b.width();
    $('.neer_image').css('height', aticleH);
  });
});

$(document).ready(function () {
  var b = $('.recommend_sq');
  var aticleH = b.width();
  $('.recommend_sq').css('height', aticleH);
});

$(function () {
  $(window).on('resize', function () {
    var b = $('.recommend_sq');
    var aticleH = b.width();
    $('.recommend_sq').css('height', aticleH);
  });
});

var shop = JSON.parse($('[data-shop]').attr('data-shop'));
var $toggleFavoriteButton = $('#toggle-favorite-button');

function addFavorite() {
  $toggleFavoriteButton.css('opacity', 0.5);
  favoriteIndicator.go(60);

  $
    .ajax({
      url: Shopnavi.url('/api/1/front/shops/' + encodeURIComponent(shop.id) + '/favorite'),
      type: 'POST',
    })
    .done(function () {
      shop.favorited = true;
      updateFavoriteStatus(shop);
    })
    .fail(function () {
      alert('お気に入りを操作中に問題が発生しました。操作をやり直して下さい。');
    })
    .always(function () {
      $toggleFavoriteButton.css('opacity', 1);
      favoriteIndicator.go(100);
    });
}

function removeFavorite(shop) {
  $toggleFavoriteButton.css('opacity', 0.5);
  favoriteIndicator.go(60);

  $
    .ajax({
      url: Shopnavi.url('/api/1/front/shops/' + encodeURIComponent(shop.id) + '/remove-favorite'),
      type: 'POST',
    })
    .done(function () {
      shop.favorited = false;
      updateFavoriteStatus(shop);
    })
    .fail(function () {
      alert('お気に入りを操作中に問題が発生しました。操作をやり直して下さい。');
    })
    .always(function () {
      $toggleFavoriteButton.css('opacity', 1);
      favoriteIndicator.go(100);
    });
}

function updateFavoriteStatus(shop) {
  var icon = shop.favorited ? '/assets/front/svg/bookmark_active.svg' : '/assets/front/svg/bookmark.svg';
  $toggleFavoriteButton.find('img').attr('src', icon);
  $toggleFavoriteButton.toggleClass('active', shop.favorited);
}

$(function () {
  $('section.single_shop_main .main .main_photoflex .photolist .imgbox').on('click', function () {
    $('#main_photo').empty();
    $(this).children('img').clone().appendTo('#main_photo');
  });

  var preventReaction = Shopnavi.customer === null;

  $('[data-review-reaction-button]').on('click', function (e) {
    e.preventDefault();

    if (preventReaction) {
      return;
    }

    var $trigger = $(e.currentTarget);
    var reviewId = $trigger.attr('data-review');
    var reacted = $trigger.attr('data-review-reaction');
    var react = reacted === '';

    preventReaction = true;
    $trigger.css('opacity', 0.5);

    if (react) {
      $.ajax({
          url: Shopnavi.endpoint + '/api/1/front/reviews/' + encodeURIComponent(reviewId) + '/react',
          type: 'POST'
        })
        .done(function () {
          $trigger.attr('data-review-reaction', 1);
        })
        .fail(function () {
          alert('操作を完了できませんでした。時間を空けてやり直して下さい。');
        })
        .always(function () {
          preventReaction = false;
          $trigger.css('opacity', 1);
        });
    } else {
      $.ajax({
          url: Shopnavi.endpoint + '/api/1/front/reviews/' + encodeURIComponent(reviewId) + '/cancel-react',
          type: 'POST'
        })
        .done(function () {
          $trigger.attr('data-review-reaction', '');
        })
        .fail(function () {
          alert('操作を完了できませんでした。時間を空けてやり直して下さい。');
        })
        .always(function () {
          preventReaction = false;
          $trigger.css('opacity', 1);
        });
    }
  });


  $toggleFavoriteButton.on('click', function (e) {
    e.preventDefault();

    if (!Shopnavi.customer) {
      $('#login-modal').modal('show');

      return;
    }

    if (shop.favorited) {
      removeFavorite(shop);
    } else {
      addFavorite(shop);
    }
  });

  updateFavoriteStatus(shop);

 $(document).ready(function () {
   var current_time = Math.round(new Date().getTime() / 1000);
   var hide_banner_end_at = window.localStorage.getItem('hide_banner_end_at');
   if (!hide_banner_end_at || current_time > hide_banner_end_at) {
     $('#sale_banner').css('display', 'block');
   }
 });
 $(document).on('click', '#sale_banner_close', function () {
   $('#sale_banner').css('display', 'none');
   var current_time = Math.round(new Date().getTime() / 1000);
   var hide_banner_end_at = current_time + 60 * 60;
   window.localStorage.setItem('hide_banner_end_at', hide_banner_end_at);
 });

});
